// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"525":"e4a0f15f","774":"d9eb88fa"}[chunkId] + ".chunk.css";
};